import { Card } from 'element-ui'

const YCard = Card
YCard.$depends = [Card]
YCard.$name = 'y-card'
YCard._name = 'Card 卡片'

export default YCard
